import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

export const imgComparisonSlider = style(
  {
    outline: 'none',
    vars: {
      '--default-handle-shadow': '0px 0px 1px rgba(0, 0, 0, 1)',
      '--divider-shadow': '0px 0px 1px rgba(0, 0, 0, 0.5)',
    },
  },
  'img-comparison-slider',
);

export const previewImage = style(
  {
    width: '100%',
    objectFit: 'contain',
    backgroundColor: themeVars.color['surface-base'],
  },
  'preview-image',
);

export const figure = style({ position: 'relative' }, 'figure');

const figcaptionBase = style(
  {
    background: themeVars.color['surface-base'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
    color: themeVars.color['text-base'],
    lineHeight: '100%',
    borderRadius: themeVars.radius['6'],
    opacity: 0.8,
    position: 'absolute',
    padding: themeVars.space['100'],
  },
  'figcaption-base',
);

export const figcaptionPositionTop = style({ top: themeVars.space['100'] }, 'figcaption-position-top');

export const figcaptionPositionBottom = style({ bottom: themeVars.space['100'] }, 'figcaption-position-bottom');

export const figcaptionAlignFirst = style({ left: themeVars.space['100'] }, 'figcaption-align-first');

export const figcaptionAlignSecond = style({ right: themeVars.space['100'] }, 'figcaption-align-second');

export const figcaption = figcaptionBase;
